import { render } from "./RichPicture.vue?vue&type=template&id=13e8f584&scoped=true"
import script from "./RichPicture.vue?vue&type=script&lang=js"
export * from "./RichPicture.vue?vue&type=script&lang=js"

import "./RichPicture.vue?vue&type=style&index=0&id=13e8f584&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e8f584"]])

export default __exports__